import React, { useState, useRef, useEffect } from 'react';
import { Container, Typography, TextField, Button, Box, InputAdornment } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import apiClient from '../services/apiClient';
import {saveToken} from "../utils/auth"; // Import the apiClient to make API requests

const Login = ({ onLogin }) => {
    const navigate = useNavigate();
    const phoneInputRef = useRef(null); // Create a ref for the phone number input
    const [phoneNumber, setPhoneNumber] = useState('');
    const [verificationCode, setVerificationCode] = useState('');
    const [isCodeSent, setIsCodeSent] = useState(false);
    const [errorMessage, setErrorMessage] = useState(''); // State for handling error messages
    const [smsValidId, setSmsValidId] = useState('');
    useEffect(() => {
        // Set focus to the phone number input field when the component mounts
        if (phoneInputRef.current) {
            phoneInputRef.current.focus();
        }
    }, []);

    const handleSendCodeClick = async () => {
        try {
            const response = await apiClient.post('/auth/sms.valid', { phone_no: phoneNumber, type: 'login' });
            if (response.status === 200) {
                setIsCodeSent(true);
                const { id } = response.data.data;
                setSmsValidId(id);
                console.log(`Verification code sent to ${phoneNumber}`);
            }
        } catch (error) {
            setErrorMessage('Failed to send verification code. Please try again.');
            console.error('Error sending verification code:', error);
        }
    };

    const handleVerifyCodeClick = async () => {
        try {


            const response = await apiClient.post('/auth/admin.login', {
                code: verificationCode,
                sms_valid_id: smsValidId,
            });
            console.log(response.data.access_token)

            if (response.status === 200) {
                saveToken(response.data.access_token)
                onLogin(); // Call the login function to update the login state
                navigate('/'); // Redirect to the main dashboard
            } else {
                setErrorMessage('Invalid verification code. Please try again.');
            }
        } catch (error) {
            setErrorMessage('Failed to verify code. Please try again.');
            console.error('Error verifying code:', error);
        }
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 5, textAlign: 'center' }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                <img src="/conomy_support.webp" alt="Conomy Support Logo" style={{ maxWidth: '100%', height: 'auto' }} />
            </Box>
            <Typography variant="h4" gutterBottom>
                Phone Number Login
            </Typography>
            <Typography variant="body1" gutterBottom>
                Please enter your phone number to receive a verification code.
            </Typography>

            {errorMessage && (
                <Typography variant="body2" color="error" gutterBottom>
                    {errorMessage}
                </Typography>
            )}

            {!isCodeSent ? (
                <Box component="form" noValidate autoComplete="off" sx={{ mt: 3 }}>
                    <TextField
                        inputRef={phoneInputRef} // Attach the ref to the phone number input
                        label="Phone Number"
                        variant="outlined"
                        fullWidth
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <PhoneIphoneIcon />
                                </InputAdornment>
                            ),
                        }}
                        sx={{ mb: 2 }}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={handleSendCodeClick}
                        disabled={!phoneNumber}
                    >
                        Send Verification Code
                    </Button>
                </Box>
            ) : (
                <Box component="form" noValidate autoComplete="off" sx={{ mt: 3 }}>
                    <Typography variant="body1" gutterBottom>
                        Enter the verification code sent to {phoneNumber}.
                    </Typography>
                    <TextField
                        label="Verification Code"
                        variant="outlined"
                        fullWidth
                        value={verificationCode}
                        onChange={(e) => setVerificationCode(e.target.value)}
                        sx={{ mb: 2 }}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={handleVerifyCodeClick}
                        disabled={!verificationCode}
                    >
                        Verify and Login
                    </Button>
                </Box>
            )}
        </Container>
    );
};

export default Login;
